import {gql, useLazyQuery} from "@apollo/client";

const GET_STANDING_ADJUSTMENT = gql`
query PointAdjustments($seasonId: Int!) {
    pointAdjustments(seasonId: $seasonId){
        id
        teamStanding{
            team{
                id
                name
            }
            stage{
                id
                name
            }
        }
        reasonComment
        reason
        points
        createdAt
    }
}
`;

export default function GetStandingAdjustments() {
    return useLazyQuery(GET_STANDING_ADJUSTMENT);
};
